<script>
import { mapGetters } from 'vuex';
import InfoButton from '@/components/inputs/buttons/InfoButton.vue'

  export default {
    name: "ComponentCardSimple",

    components: {
      InfoButton
    },
    props: {
      data: Object,
      datatype: String,
      isselected: Boolean,
      // cselected: Boolean,
      // wSelected: Object, // selected wall data
      scolor: Object,
      soption: null,
      // svariant: Object,
      // sglasType: Object,
    },

    emits: ['select', 'change'],

    data () {
      // console.log('component card data',this.data)
      return {
        models: import.meta.env.VITE_VUE_APP_MODELS_LOCATION,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        host: import.meta.env.VITE_VUE_APP_TEXTURE_LOCATION,
        selectedColorIndex: 0,
        selectedOptionIndex: 0,
        // lastCodeSelection: '' // for choosing .glb file
        onMobile: false,
        specsVisible: false,
        hasGlowingCloseBtn: false,
        infoboxID: null
      }
    },

    computed: {
      ...mapGetters({
        infoboxes: 'getInfoboxes'
      }),
      getFullInfoboxData() {
        return this.infoboxes.find(info => info.id === this.infoboxID)
      }
    },

    watch: {
      // wSelected: "setCurrentComponentSettings",
    },

    created() {
      let regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      this.onMobile = regex.test(navigator.userAgent)
      this.$nextTick(() => {
          document.getElementById('fullcoverForComponentCardSimple')
            .addEventListener('click', function (/*event*/) {
                // console.log('TEST',event)
            });
        })
    },

    mounted() {
      // this.setCurrentComponentSettings()
    },

    methods: {
      handleCardClick(data) {
        // console.log('handleCardClick')
        this.$emit('select', data)
      },
      changeColor (color) {
        this.$emit('change', color)
      },

      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs() {
        this.specsVisible = !this.specsVisible;
        if (this.specsVisible) {
          this.$nextTick(() => {
            document.getElementById('fullcoverForComponentCardSimple')?.focus();
          });
        }
      }
    },
  }
</script>

<template>
  <!-- <button class="button-wrapper" @click="$emit('select')"> -->
  <button class="button-wrapper" @click="handleCardClick(data)" style="position: relative">
    <InfoButton 
      v-if="data.infobox && data.infoboxOnline"
      minimized="true"
      @showspecs="infoboxID = data.infobox; enableAndHoldSpecs();"
    />
    <div class="card" :class="isselected ? 'card-selected' : '' ">
      <div class="card-header">
        <img 
          v-if="datatype === 'dakafwerking' && data.previewURL" 
          :src="host + data.previewURL" 
          alt=""
          @error="setBackupImage($event, data)"
        >
        <img 
          v-if="datatype === 'lichtstraten' && data.colors[data.colorPicked]?.code"
          :src="`${previewsServer + models}previews/${data.colors[data.colorPicked].code}.png`" 
          :alt="data.code"
          @error="setBackupImage($event, data)"
        >

        <!-- COLORS -->
        <div class="card-header-colors" v-if="data.colors">
          <button 
            v-for="(color, index) in data.colors" 
            :key="index" 
            class="card-header-colors-button" 
            :title="`${color.name} (${color.code})`"
            :style="`background-color: ${color.hexCode};`"
            :class="isselected ? scolor?.code === color.code ? 'card-header-colors-button-active' : '' : index === selectedColorIndex ? 'card-header-colors-button-active' : ''"
            @click.stop="selectedColorIndex = index; lastCodeSelection = color.code; $emit('select')"
          />
        </div>
      </div>

      <!-- CARD INFO -->
      <!-- title = hover text over button -->
      <div class="card-info">
        <h3>{{ data.colors[selectedColorIndex].componentName }}</h3>
      </div>
      <div v-if="datatype === 'lichtstraten'" class="card-info-size">
        <mdicon class="card-info-size-icon" name="ruler-square" size="25" />
        <span class="card-info-size-text">{{ data.size }} mm</span>
      </div>

      <!-- OPTIONS -->
      <!-- title = hover text over button -->
      <!-- <div class="card-options" v-if="data.options?.length > 0">
        <button 
          v-for="(option, index) in data.options" 
          :key="index"
          :class="cselected ? soption.subCode === option.subCode ? 'card-options-active' : '' : index === selectedOptionIndex ? 'card-options-active' : ''"    
          @click="selectedOptionIndex = index; $emit('select')"
          >
          {{ option.name }}
        </button>
      </div> -->
    </div>
  </button>
  <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcoverForComponentCardSimple"
        tabindex="-1"
        @click="specsVisible = false"
        @keydown.escape="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
          <button 
            class="modalclosebutton" 
            @mouseover="specsCloseBtnMouseOver" 
            @mouseleave="specsCloseBtnMouseLeave"
            @click="specsVisible = false"
          >
            <Transition name="closebtn">
              <div 
                v-show="hasGlowingCloseBtn"
                class="absolutepos glowingclose"
              />
            </Transition>
            <div>
              ×
            </div>
          </button>
          <div class="imagescroller">
            <!-- {{ data }} -->
            <img 
              class="modalimage" 
              :src="`/infoboximages/${getFullInfoboxData?.urlEnding}`" 
              alt=""
            >
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style lang="scss" scoped>

.card {
  display: flex;
  flex-grow: 1;
  height: calc(100% - 20px);
  flex-direction: column;
  outline: 3px solid $c-border-1;
  border-radius: $radius-m;
  padding: 10px;
  transition: outline-color 100ms ease;
  border: none;
  background-color: transparent;
  scroll-margin: 150px;

  &:hover {
    outline-color: $c-secondary;
    cursor: pointer;
  }

  &-selected {
    outline-color: $c-secondary;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    height: 150px;
    max-width: 100%;

    & img {
      min-height: 150px;
      max-height: 150px;
      width: calc(100% - 24px);
      object-fit: contain;
    }

    &-colors {
      display: flex;
      flex-direction: column;
      gap: 6px;

      &-button {
        height: 24px;
        width: 24px;
        outline: 3px solid $c-border-1;
        outline-offset: -2px;
        border: none;
        border-radius: $radius-s;
        transition: outline-color 100ms ease;
        cursor: pointer;

        &:hover {
          outline-color: $c-secondary;
        }

        &-active {
          outline-color: $c-secondary;
        }
      }
    }

    &-glastypes {
      display: flex;
      flex-direction: column;
      gap: 6px;

      &-button {
        height: 24px;
        width: 32px;
        outline: 3px solid $c-border-1;
        outline-offset: -2px;
        border: none;
        border-radius: $radius-s;
        transition: outline-color 100ms ease;
        cursor: pointer;
        margin-right: 0.4em;

        &:hover {
          outline-color: $c-secondary;
        }

        &-active {
          outline-color: $c-secondary;
        }        
      }
    }
  }

  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;

    min-height: 2.8rem;

    & h3 {
      font-size: 1rem;
      text-align: left;
    }

    &-size {
      display: flex;
      align-items: center;
      gap: 15px;
      font-weight: 500;
    }
  }

  &-options {
    display: flex;
    gap: 15px;

    & button {
      flex-grow: 1;
      background-color: $c-background-1;
      border: none;
      border-radius: $radius-s;
      padding: 5px;
      font-weight: 600;
      font-size: 0.9rem;
      color: $c-primary;
      transition: color 100ms ease, background-color 100ms ease;
      cursor: pointer;
    }

    &-active {
      background-color: $c-primary !important;
      // color: $c-secondary  !important;
      color: $c-secondary-bright  !important;
    }
  }
}

.button-wrapper {
  border: none;
  display: flex;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
}

#fullcoverForComponentCardSimple {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  left: 50%;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}

.imagescroller {
  max-height: calc(98%);
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

.glowingclose {
  border-radius: 20px;
}

</style>